'use client';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PanelSkeleton = ({ tall = false }: { tall?: boolean }) => (
  <section className="rounded-lg border bg-card p-4">
    <Skeleton height={14} width={140} className="mb-3" />
    <Skeleton height={tall ? 240 : 120} borderRadius="0.5rem" />
  </section>
);

export function ReportViewerSkeleton() {
  return (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
      <div className="space-y-4">
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton height={12} width={88} />
          <Skeleton height={24} width={120} borderRadius="9999px" />
          <Skeleton height={12} width={72} />
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="col-span-full lg:col-span-1">
            <PanelSkeleton />
          </div>
          <div className="col-span-full lg:col-span-1">
            <PanelSkeleton />
          </div>
          <div className="col-span-full">
            <PanelSkeleton tall />
          </div>
          <div className="col-span-full">
            <PanelSkeleton tall />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
}
